import { Helmet } from 'react-helmet-async';

const defaultMeta = {
  siteName: 'Personal Fußballtraining',
  siteUrl: 'https://personal-fussballtraining.de',
  defaultImage: 'https://personal-fussballtraining.de/og-image.jpg',
  twitterHandle: '@fussballaktas',
};

export default function SEO({ 
  title, 
  description, 
  path = '', 
  image,
  noIndex = false 
}) {
  const fullUrl = `${defaultMeta.siteUrl}${path}`;
  const imageUrl = image || defaultMeta.defaultImage;
  
  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <link rel="canonical" href={fullUrl} />
      
      {/* Robots */}
      <meta name="robots" content={noIndex ? 'noindex, nofollow' : 'index, follow'} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={imageUrl} />
      <meta property="og:site_name" content={defaultMeta.siteName} />
      <meta property="og:locale" content="de_DE" />
      
      {/* Twitter / X */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={fullUrl} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={imageUrl} />
      
      {/* Additional SEO */}
      <meta name="author" content="Yasin Aktas" />
      <meta name="geo.region" content="DE-NW" />
      <meta name="geo.placename" content="Meinerzhagen" />
      <html lang="de" />
    </Helmet>
  );
}
